export default __webpack_public_path__ + "static/media/Ubuntu-L.62c0fe51.woff";